import React from 'react';
import { graphql, Link } from 'gatsby'
import styled from 'styled-components'

import Layout from "../components/layout"
import SEO from "../components/seo"

const LinksField = styled.div`
  display: flex;
  justify-content: flex-start;
  margin: 1rem;
  & > * {
    margin-right: 3rem;
  }
`

export default function Template({ data }) {
  // const post = data.markdownRemark;
  const { markdownRemark: post } = data;

  return (
    <Layout>
      <SEO title={post.frontmatter.title} />
      <h1>{post.frontmatter.title}</h1>
      <LinksField>
        <a href={post.frontmatter.demo} target="_blank" rel="noopener noreferrer">Demo</a>
        <a href={post.frontmatter.repo} target="_blank" rel="noopener noreferrer">Repozytorium</a>
      </LinksField>
      <div dangerouslySetInnerHTML={{ __html: post.html }} />
      <Link to="/projects/">{`<< PROJEKTY`}</Link>
    </Layout>
  )
}

export const postQuery = graphql`
  query PostQueryByPath($slug: String!) {
    markdownRemark(frontmatter: { slug: { eq: $slug } }) {
      html
      frontmatter {
        slug
        title
        demo
        repo
        date(formatString: "MMMM YYYY", locale: "pl-PL")
      }
    }
  }
`